import { useQuery } from '@tanstack/react-query';
import { tenantApi } from '../services/tenantApi';
import { Location } from '../state/tenantAuth';

export function useLocations() {
  return useQuery({
    queryKey: ['locations'],
    queryFn: () => tenantApi.getList<Location>('/locations'),
  });
}
